import { FundingChartAggregatePeriod } from '@lyra/core/constants/chart'
import { Period } from '@lyra/core/constants/time'

export function groupPortfolioSnapshots<T extends { timestamp: number; subaccountValue: number }>(
  snapshots: T[],
  startTimestamp: number,
  endTimestamp: number,
  period: number
): T[] {
  if (!snapshots.length) {
    return []
  }

  let snapshotIdx = 0
  const smoothSnapshots: T[] = []
  let timestamp = startTimestamp

  // Iterate over the timestamps
  for (; timestamp < endTimestamp + period; timestamp += period) {
    let snapshot: T

    // Find the closest snapshot that doesn't exceed the current timestamp
    while (
      snapshotIdx < snapshots.length - 1 &&
      snapshots[snapshotIdx + 1].timestamp <= timestamp
    ) {
      snapshotIdx++
    }

    if (snapshots[snapshotIdx].timestamp <= timestamp) {
      // Clone the object to avoid mutating the original snapshots
      snapshot = { ...snapshots[snapshotIdx] }
    } else {
      // Create a snapshot with zero dollars if no snapshot is found
      snapshot = { timestamp, subaccountValue: 0 } as T
      continue
    }

    // Ensure timestamp is not greater than endTimestamp
    snapshot.timestamp = Math.min(timestamp, endTimestamp)
    snapshot.subaccountValue = Math.round((snapshot.subaccountValue + Number.EPSILON) * 100) / 100
    smoothSnapshots.push(snapshot)
  }
  return smoothSnapshots
}

export function formatCandlePeriodLabel(period: Period): string {
  switch (period) {
    case Period.FifteenMinutes:
      return '15M'
    case Period.OneHour:
      return '1H'
    case Period.FourHours:
      return '4H'
    case Period.EightHours:
      return '8H'
    case Period.OneDay:
      return '1D'
  }
  return ''
}

export const formatFundingPeriodLabel = (interval: FundingChartAggregatePeriod): string => {
  switch (interval) {
    case FundingChartAggregatePeriod.OneHour:
      return '1H Rate'
    case FundingChartAggregatePeriod.EightHours:
      return '8H Rate'
    case FundingChartAggregatePeriod.OneYear:
      return 'Annualized Rate'
  }
}
